(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["blog-events"]) return;
  try {
    
var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
  pInfScrNode = $('.load-more').last(); 
  pInfScrURL = $('.load-more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".events-post-matrix");
        filteredData.insertBefore( $("#events-list-foot") );         
        pInfScrLoading = false;
        attachClickEvent();
      },
      dataType: "html"
    });

  }
}

function attachClickEvent(){
  $('div.load-more a').click(function(event){
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });
}

$(document).ready(function () {
  attachClickEvent();
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-influencers"]) return;
  try {
    
var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
  pInfScrNode = $('.load-more').last(); 
  pInfScrURL = $('.load-more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        console.log(data)
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".js-Influencers_Page");
        filteredData.insertBefore( $("#js-Influencers_Footer") );         
        pInfScrLoading = false;
        attachClickEvent();
      },
      dataType: "html"
    });

  }
}

function attachClickEvent(){
  $('div.load-more a').click(function(event){
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });
}

$(document).ready(function () {
  attachClickEvent();
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
var pInfScrLoading = false;
var pInfScrDelay = 250;
function pInfScrExecute() {
  pInfScrNode = $('.load-more').last(); 
  pInfScrURL = $('.load-more a').last().attr("href");
  if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
    $.ajax({
      type: 'GET',
      url: pInfScrURL,
      beforeSend: function() {
        pInfScrLoading = true;
        pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
        pInfScrNode.hide();
      },
      success: function(data) {
        // remove loading feedback
        pInfScrNode.next().remove();
        pInfScrNode.remove();
        var filteredData = $(data).find(".blog-post-matrix");
        filteredData.insertBefore( $("#article-list-foot") );         
        pInfScrLoading = false;
        attachClickEvent();
      },
      dataType: "html"
    });

  }
}

function attachClickEvent(){
  $('div.load-more a').click(function(event){
    pInfScrExecute();
    event.stopPropagation();
    return false;
  });
}

$(document).ready(function () {
  attachClickEvent();
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-products"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function(){

		$(document).on("shopify:section:load", function(e){
			console.log("HAHA IVE JUST LOADED");
			
			$(".product-slider").each(function(){
				console.log($(this).data("speed"))
				console.log($(this).data("autoplay"))
				console.log($(this).data("dots"))
				$(this).slick({
					autoplaySpeed: parseFloat($(this).data("aspeed")) * 1000,
					speed: parseFloat($(this).data("speed")) * 1000,
					autoplay: $(this).data("autoplay"),
					dots: $(this).data("dots"),
					slidesToShow: parseInt($(this).data("show")),
					slidesToScroll: parseInt($(this).data("scroll")),
					arrows: true,
					responsive: [
					    {
					      breakpoint: 768,
					      settings: {
					        slidesToShow: 2,
					        slidesToScroll: 2
					      }
					    }
					]
				})

			})

			
		})

	})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-slider"] && !window.DesignMode) return;
  try {
    
	$(document).ready(function(){

		$(document).on("shopify:section:load", function(e){
			$(".homepage-slider").each(function(){
				$(this).slick({
					autoplaySpeed: parseFloat($(this).data("aspeed")) * 1000,
					speed: parseFloat($(this).data("speed")) * 1000,
					autoplay: false,
					dots: $(this).data("dots"),
					fade: $(this).data("fade"),
					arrows: false,
					pauseOnHover: false,
					mobileFirst: true,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								autoplay: $(this).data("autoplay")
							}
						}
					]
				})
			})
		})
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sponsorship-single"]) return;
  try {
    
  $(".product-grid").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    arrows: false,
    responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
    ]
  })

  } catch(e) { console.error(e); }
})();

})();
